import { render } from "./ProductList.vue?vue&type=template&id=24e08850&scoped=true"
import script from "./ProductList.vue?vue&type=script&lang=js"
export * from "./ProductList.vue?vue&type=script&lang=js"

import "./ProductList.vue?vue&type=style&index=0&id=24e08850&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e08850"],['__file',"src/views/qywx/crm/product/ProductList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24e08850"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24e08850', __exports__)) {
    api.reload('24e08850', __exports__)
  }
  
  module.hot.accept("./ProductList.vue?vue&type=template&id=24e08850&scoped=true", () => {
    api.rerender('24e08850', render)
  })

}


export default __exports__